<template>
  <div>
    <div class="outer-filter-container">
      <div class="j-container filter-container">
        <transition-group name="file-type">
          <div
            class="filter"
            :class="{ active: selectedType === v.type }"
            v-for="v in this.fileTypes"
            :key="v.type"
            @click="handleTypeChange(v.type)"
          >
            {{ $t(v.code) }}
          </div>
        </transition-group>
      </div>
    </div>
    <Banner type="product" />
    <div class="page-container j-container-box-shadow container">
      <span class="j-title title">{{ getTitle() }}</span>
      <div>
        <div class="sub-title">{{ $t(`download.pic.subtitle`) }}</div>
        <a-spin :spinning="loading">
          <div>
            <a-row :gutter="[45, 45]" v-if="fileList.length > 0">
              <a-col
                :xs="24"
                :sm="24"
                :md="8"
                v-for="item in fileList"
                :key="item.id"
              >
                <FileItem :file="item" />
              </a-col>
            </a-row>
            <div class="j-no-result" v-if="loaded && fileList.length === 0">
              <img
                alt="no-data"
                src="@/assets/images/noData.png"
                width="164"
                height="141"
              />
              <span class="no-data-msg j-content">
                {{ $t('common.coming_soon') }}
              </span>
            </div>
          </div>
        </a-spin>

        <div class="pagination-container" v-if="fileList.length > 0">
          <a-pagination
            v-model:current="pageNo"
            :page-size-options="pageSizeOptions"
            :total="total"
            show-size-changer
            v-model:pageSize="pageSize"
            @showSizeChange="onShowSizeChange"
            @change="onChange"
            show-quick-jumper
          >
            <template #buildOptionText="props">
              <span
                >{{ props.value }} {{ $t('common.page_per_item_text') }}</span
              >
            </template>
          </a-pagination>
        </div>
      </div>
      <div>
        <div class="sub-title">{{ $t(`download.video.subtitle`) }}</div>
        <a-spin :spinning="loading">
          <div>
            <a-row :gutter="[45, 45]" v-if="videoFileList.length > 0">
              <a-col
                :xs="24"
                :sm="24"
                :md="8"
                v-for="item in videoFileList"
                :key="item.id"
              >
                <FileItem :file="item" />
              </a-col>
            </a-row>
            <div
              class="j-no-result"
              v-if="loaded && videoFileList.length === 0"
            >
              <img
                alt="no-data"
                src="@/assets/images/noData.png"
                width="164"
                height="141"
              />
              <span class="no-data-msg j-content">
                {{ $t('common.coming_soon') }}
              </span>
            </div>
          </div>
        </a-spin>

        <div class="pagination-container" v-if="videoFileList.length > 0">
          <a-pagination
            v-model:current="videoPageNo"
            :page-size-options="pageSizeOptions"
            :total="videoTotal"
            show-size-changer
            v-model:pageSize="videoPageSize"
            @showSizeChange="onVideoShowSizeChange"
            @change="onVideoChange"
            show-quick-jumper
          >
            <template #buildOptionText="props">
              <span
                >{{ props.value }} {{ $t('common.page_per_item_text') }}</span
              >
            </template>
          </a-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Banner from '@/components/banner/Banner.vue';
import { mapState } from 'vuex';
import FileItem from './downloadcenter/FileItem.vue';
import { getDownloadFileByType } from '@/api/apis';

export default defineComponent({
  name: 'Product',
  components: {
    Banner,
    FileItem
  },
  data() {
    return {
      loading: false,
      loaded: false,
      pageNo: 1,
      pageSize: 3,
      videoPageNo: 1,
      videoPageSize: 3,
      pageSizeOptions: ['3', '6', '12'],
      current: 1,
      total: 0,
      fileList: [],
      videoFileList: [],
      videoTotal: [],
      fileTypes: [
        {
          code: 'download.public_file',
          type: 0
        },
        {
          code: 'download.sale_after_file',
          type: 1
        }
      ],
      selectedType: 0,
      expand: false
    };
  },
  created() {
    this.loadFileList();
    this.loadVideoFileList();
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {
    lang() {
      this.loadFileList();
      this.loadVideoFileList();
    }
  },
  methods: {
    handleTypeChange(fileType) {
      if (fileType !== this.selectedType) {
        this.selectedType = fileType;
        this.pageNo = 1;
        this.videoPageNo =1;
        this.loadFileList();
        this.loadVideoFileList();
      }
    },
    getTitle() {
      const item = this.fileTypes.find(
        (s: any) => s.type === this.selectedType
      );
      return item ? this.$t(item.code) : '';
    },

    async loadFileList() {
      this.loading = true;
      this.loaded = false;
      const vRes1 = await getDownloadFileByType({
        subType: 1,
        type: this.selectedType,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });

      if (vRes1.success) {
        this.fileList = vRes1.result.records || [];
        this.total = vRes1.result.total;
      }

      this.loading = false;
      this.loaded = true;
    },
    async loadVideoFileList() {
      this.loading = true;
      this.loaded = false;
      const vRes2 = await getDownloadFileByType({
        subType: 2,
        type: this.selectedType,
        pageNo: this.videoPageNo,
        pageSize: this.videoPageSize
      });
      if (vRes2.success) {
        this.videoFileList = vRes2.result.records || [];
        this.videoTotal = vRes2.result.total;
      }
      this.loading = false;
      this.loaded = true;
    },
    onShowSizeChange() {
      this.pageNo = 1;
      this.loadFileList();
    },

    onVideoShowSizeChange() {
      this.videoPageNo = 1;
      this.loadVideoFileList();
    },

    onChange() {
      this.loadFileList();
    },
    onVideoChange() {
      this.loadVideoFileList();
    }
  }
});
</script>

<style lang="scss" scoped>
.outer-filter-container {
  background: $secondary-color1;

  .filter-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .filter {
      padding: 12px 30px;
      cursor: pointer;
      color: $primary-secondary-forecolor;

      &.active {
        background: $primary-color;
        color: white;
        transition: all 0.5s;
      }
    }
  }
}

.container {
  padding: 0 49px;
  background-color: white;

  .title {
    padding: 32px 0 29px 0;
    display: block;
  }
  .sub-title {
    font-size: 23px;
    color: #039;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .pagination-container {
    padding: 38px 0 40px 0;
    text-align: right;
  }
}

.vehicle-type-enter-active,
.vehicle-type-leave-active {
  transition: opacity 250ms ease;
}

.vehicle-type-enter-from,
.vehicle-type-leave-to {
  opacity: 0;
}
</style>
